import { Component, OnInit, Input, Output, EventEmitter, Self, ChangeDetectorRef } from '@angular/core';
import { ObjectProperties } from '../../../../../../../../../../../common/components/data-table/models/column.interface';
import { MenuItemComponent } from '../../../../../../../../../../../common/components/menu/menu-item/menu-item.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'property-node',
    templateUrl: './property-node.component.html',
    styleUrls: ['./property-node.component.scss'],
    standalone: false
})
export class PropertyNodeComponent {
    @Input()
    object: ObjectProperties;
    @Output()
    selectedProperty: EventEmitter<ObjectProperties> = new EventEmitter();
    @Output()
    onHover: EventEmitter<PropertyNodeComponent> = new EventEmitter();

    constructor(
        public menuItem: MenuItemComponent,
        public changeDetector: ChangeDetectorRef
    ) {
        this.menuItem.hoverChanged.subscribe((r) => {
            this.onHover.next(this);
        });
    }
}
